<template>
  <div class="big-number">
    <el-tooltip
      class="item"
      effect="dark"
      :content="''+BIGNUM.toSmallNumStr(number||0)"
      placement="top"
    >
      <span>{{showNumber}}</span>
    </el-tooltip>
  </div>
</template>

<script>
import { fixed } from "@/utils/bigNumberTran.js"
export default {
  props: {
    number: {
      type: [Number, String, Object],
      default: () => {
        return 0;
      }
    },
    count: {
      type: [Number, String, Object],
      default: () => {
        return 4;
      }
    },
  },
  data() {
    return {};
  },
  computed: {
    showNumber(){
      return fixed(this.BIGNUM.toSmallNumStr(this.number || 0),this.count);
    }

  },
  methods: {
  },
  created() {},
  watch: {}
};
</script>
<style scoped lang="scss">
.big-number{
  display: inline-block;
  font-size: 0.2rem;
}
</style>
